import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store/store';
import { IMedicalDesk, IClientService, ICommonStatistics, IStatisticsState } from './types/statistics-interface';

const selectStatisticsState = (state: RootState): IStatisticsState => state.statistics;

export const MedicalDesk = createSelector(
    [selectStatisticsState],
    (statisticsState: IStatisticsState): IMedicalDesk => statisticsState.MedicalDesk,
);

export const ClientService = createSelector(
    [selectStatisticsState],
    (statisticsState: IStatisticsState): IClientService => statisticsState.ClientService,
);

export const CommonStatistics = createSelector(
    [selectStatisticsState],
    (statisticsState: IStatisticsState): ICommonStatistics => statisticsState.CommonStatistics,
);
export const selectIsLoading = createSelector(
    [selectStatisticsState],
    (statisticsState: IStatisticsState): boolean => statisticsState.activeRequestsCount > 0,
);